import { useState, useEffect, useCallback } from "react";
import { useAuth } from "../context/AuthContext";

const API = process.env.REACT_APP_BACKEND_URL;

// L'admin peut consulter les 3 guides ; les autres roles ne voient que le leur.
const ADMIN_TABS = [
  { key: "foodtruck", label: "Food Truck" },
  { key: "bureau", label: "Bureau" },
  { key: "admin", label: "Admin" },
];

/**
 * Affiche le guide correspondant au role du compte connecte. Le serveur ne
 * renvoie que le guide autorise : un food truck ne recoit jamais le guide
 * bureau/admin. Un ADMIN dispose d'un selecteur pour consulter les 3 guides.
 * Le contenu est rendu dans une iframe isolee.
 */
export default function GuidePage() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [which, setWhich] = useState("admin");
  const [html, setHtml] = useState("");
  const [status, setStatus] = useState("loading"); // loading | ok | error

  const load = useCallback(
    async (roleKey) => {
      setStatus("loading");
      try {
        const token = localStorage.getItem("token");
        const q = isAdmin && roleKey ? `?role=${roleKey}` : "";
        const res = await fetch(`${API}/api/guide${q}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error(String(res.status));
        const text = await res.text();
        setHtml(text);
        setStatus("ok");
      } catch (e) {
        setStatus("error");
      }
    },
    [isAdmin],
  );

  useEffect(() => {
    load(isAdmin ? which : null);
  }, [load, which, isAdmin]);

  const tabBtn = (active) => ({
    padding: "7px 16px",
    borderRadius: "9px",
    border: "1px solid " + (active ? "transparent" : "#e5e0dc"),
    background: active ? "#8B1538" : "#fff",
    color: active ? "#fff" : "#6a5c53",
    fontWeight: 600,
    fontSize: "0.88rem",
    cursor: "pointer",
  });

  return (
    <div>
      {isAdmin && (
        <div style={{ display: "flex", gap: "8px", marginBottom: "14px", flexWrap: "wrap" }}>
          {ADMIN_TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              onClick={() => setWhich(t.key)}
              style={tabBtn(which === t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>
      )}

      {status === "loading" && (
        <div style={{ minHeight: "50vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div className="animate-spin rounded-full h-10 w-10 border-4 border-primary border-t-transparent"></div>
        </div>
      )}

      {status === "error" && (
        <div style={{ padding: "28px" }}>
          <h1 className="text-xl font-bold text-secondary">Guide indisponible</h1>
          <p className="text-gray-600 mt-2">
            Impossible de charger le guide pour le moment. Actualisez la page, ou contactez un administrateur.
          </p>
        </div>
      )}

      {status === "ok" && (
        <iframe
          title="Guide d'utilisation"
          srcDoc={html}
          style={{
            width: "100%",
            height: isAdmin ? "calc(100vh - 180px)" : "calc(100vh - 130px)",
            minHeight: "600px",
            border: "1px solid #e5e0dc",
            borderRadius: "12px",
            background: "#fff",
          }}
        />
      )}
    </div>
  );
}
